var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AE558910-CF4A-40A3-B21F-941724562BB9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S6070---Home-Page-|-User-Profile-menu",
    transform: "translate(-1084.000000, -146.000000)",
    fill: "#4884E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "options-menu",
    transform: "translate(1060.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Support",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-actions-/-add-funds",
    transform: "translate(24.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(2.666667, 2.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2395833,7.59088542 C23.3901563,7.59088542 24.3229167,8.52364583 24.3229167,9.67421875 L24.3229167,9.67421875 L24.3229167,13.2419271 L20.6770833,13.2419271 C18.5231771,13.2419271 16.7708333,14.9942708 16.7708333,17.1481771 C16.7708333,19.3020833 18.5231771,21.0544271 20.6770833,21.0544271 L20.6770833,21.0544271 L24.3229167,21.0544271 L24.3229167,24.5833333 C24.3229167,25.7339062 23.3901563,26.6666667 22.2395833,26.6666667 L22.2395833,26.6666667 L2.08333333,26.6666667 C0.932760417,26.6666667 0,25.7339062 0,24.5833333 L0,24.5833333 L0,9.67421875 C0,8.52364583 0.932760417,7.59088542 2.08333333,7.59088542 L2.08333333,7.59088542 Z M25.8854167,14.8044271 C26.3161979,14.8044271 26.6666667,15.1548958 26.6666667,15.5856771 L26.6666667,15.5856771 L26.6666667,18.7106771 C26.6666667,19.1414583 26.3161979,19.4919271 25.8854167,19.4919271 L25.8854167,19.4919271 L20.6770833,19.4919271 C19.3847396,19.4919271 18.3333333,18.4405208 18.3333333,17.1481771 C18.3333333,15.8558333 19.3847396,14.8044271 20.6770833,14.8044271 L20.6770833,14.8044271 Z M20.6770833,16.3669271 C20.245625,16.3669271 19.8958333,16.7167187 19.8958333,17.1481771 C19.8958333,17.5796354 20.245625,17.9294271 20.6770833,17.9294271 C21.1085417,17.9294271 21.4583333,17.5796354 21.4583333,17.1481771 C21.4583333,16.7167187 21.1085417,16.3669271 20.6770833,16.3669271 Z M13.1386979,0 C13.5655729,0 13.9660938,0.264322917 14.1189583,0.689322917 L14.1189583,0.689322917 L14.3908333,1.44505208 L13.4895833,1.44505208 C12.0536458,1.44505208 10.8854167,2.61328125 10.8854167,4.04921875 L10.8854167,4.04921875 L10.8854167,6.02838542 L3.53494792,6.02838542 L3.05375,4.71494792 C2.85552083,4.17395833 3.13416667,3.57484375 3.67557292,3.37776042 L3.67557292,3.37776042 L12.7825,0.063125 C12.9001042,0.0203125 13.0204167,0 13.1386979,0 Z M20.5208333,3.00755208 C21.0961458,3.00755208 21.5625,3.47390625 21.5625,4.04921875 L21.5625,4.04921875 L21.5625,6.02838542 L12.4479167,6.02838542 L12.4479167,4.04921875 C12.4479167,3.47390625 12.9142708,3.00755208 13.4895833,3.00755208 L13.4895833,3.00755208 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.03038d5f.svg";
export { ForwardRef as ReactComponent };